var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-alert",
    {
      staticClass: "feed-manager__alert",
      attrs: { persistent: true, tinted: "", variation: "warning" },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.description) + "\n  "),
      _c("mds-button", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.attestationMessage,
            expression: "!attestationMessage",
          },
        ],
        attrs: {
          slot: "mds-alert-custom-action",
          target: "_blank",
          href: _vm.DATA_DISTRIBUTION_URL,
          text: _vm.translate("limitedAccess.button"),
        },
        slot: "mds-alert-custom-action",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }